import { Navigate } from 'react-router-dom';

import { ROUTES } from '@/config/routes.ts';
import { useHydration } from '@/hooks/useHydration';
import { useAuthStore } from '@/stores/auth-store';

export default function RoleLanding() {
  const hydrated = useHydration();
  const user = useAuthStore(s => s.user);

  if (!hydrated) {
    return null;
  }

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  switch (user.role) {
    case 'SUPER_ADMIN':
      return <Navigate to={ROUTES.ADMIN_DASHBOARD} replace />;
    case 'ORGANIZATION_ADMIN':
      return <Navigate to={ROUTES.ORGANIZER_DASHBOARD} replace />;
    case 'CLUB_ADMIN':
      return <Navigate to={ROUTES.CLUB_DASHBOARD} replace />;
    case 'MEMBER':
      return <Navigate to={ROUTES.PLAYER_DASHBOARD} replace />;
    default:
      return <Navigate to={ROUTES.LOGIN} replace />;
  }
}
